import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/leadership/client/CoreTeamClient.tsx");
